var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiLogoShort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 37.777 17.569",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 57433"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1.074,
    "data-name": "Group 57428"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#707070",
    "data-name": "Group 15284",
    style: {
      isolation: "isolate",
      mixBlendMode: "normal"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m14.941 3.585.562-.681a1.97 1.97 0 0 0 1.291.531c.389 0 .624-.156.624-.425 0-.243-.148-.368-.871-.556-.871-.225-1.433-.468-1.433-1.349a1.36 1.36 0 0 1 1.514-1.318 2.5 2.5 0 0 1 1.606.556l-.494.725a2 2 0 0 0-1.124-.431c-.364 0-.556.169-.556.394 0 .287.185.381.933.575.877.231 1.372.55 1.372 1.324 0 .868-.655 1.355-1.588 1.355a2.74 2.74 0 0 1-1.836-.7Z",
    "data-name": "Path 18558"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1.741h-1.316v-.886h3.584v.886h-1.317v3.483H20.1Z",
    "data-name": "Path 18559"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.721 2.04a2.3 2.3 0 1 1 2.292 2.261 2.25 2.25 0 0 1-2.292-2.261zm3.6 0A1.32 1.32 0 0 0 25.012.666a1.3 1.3 0 0 0-1.3 1.374 1.32 1.32 0 0 0 1.31 1.374 1.3 1.3 0 0 0 1.3-1.374z",
    "data-name": "Path 18560"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.157-.145h1.975a1.7 1.7 0 0 1 1.26.443 1.4 1.4 0 0 1 .37 1.011 1.356 1.356 0 0 1-.926 1.355l1.056 1.561h-1.111l-.938-1.4h-.735v1.4h-.951Zm1.914 2.122c.463 0 .729-.25.729-.631 0-.412-.284-.624-.747-.624h-.945v1.255Z",
    "data-name": "Path 18561"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.681 2.5 32.02-.147h1.112l1.036 1.755 1.05-1.754h1.081l-1.662 2.628v1.742h-.951z",
    "data-name": "Path 18562"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#1aa9b4",
    d: "M15.201 6.405h2.344l2.6 4.226 2.6-4.226h2.344v10h-2.16V9.88l-2.782 4.269h-.056l-2.753-4.226v6.483h-2.137Z",
    "data-name": "Path 19285"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#1aa9b4",
    d: "M27.781 6.4h3.855a5 5 0 1 1 0 10h-3.855zm3.855 8.01a3.013 3.013 0 0 0 0-6.026h-1.68v6.026z",
    "data-name": "Path 19286"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1aa9b4",
    "data-name": "Group 57425"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.321 16.99a7.45 7.45 0 0 1 2.245-5.472 7.45 7.45 0 0 1 5.472-2.245 7.45 7.45 0 0 1-5.472-2.245 7.45 7.45 0 0 1-2.245-5.472 7.45 7.45 0 0 1-2.245 5.471A7.45 7.45 0 0 1-.396 9.272a7.45 7.45 0 0 1 5.472 2.245 7.45 7.45 0 0 1 2.245 5.473"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.091 8.28a3.94 3.94 0 0 1 1.013-2.736 3.2 3.2 0 0 1 2.469-1.123 3.2 3.2 0 0 1-2.469-1.123A3.94 3.94 0 0 1 11.091.563a3.94 3.94 0 0 1-1.013 2.736 3.2 3.2 0 0 1-2.469 1.123 3.2 3.2 0 0 1 2.469 1.123 3.94 3.94 0 0 1 1.013 2.735M3.075 6.883a2.67 2.67 0 0 1 .718-1.887 2.3 2.3 0 0 1 1.75-.774 2.3 2.3 0 0 1-1.75-.775 2.67 2.67 0 0 1-.718-1.887 2.67 2.67 0 0 1-.718 1.887 2.3 2.3 0 0 1-1.75.775 2.3 2.3 0 0 1 1.75.774 2.67 2.67 0 0 1 .718 1.887",
    "data-name": "book_4_spark_24dp_5F6368_FILL1_wght400_GRAD0_opsz24"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiLogoShort);
export default __webpack_public_path__ + "static/media/ai-logo-short.991785e5b069a87c79b852c6ff9f4f90.svg";
export { ForwardRef as ReactComponent };